import { ArrowRight } from "lucide-react";
import { SOLARRECHNER_URL } from "@/lib/site";

interface Props {
  className?: string;
  label?: string;
}
const SolarrechnerButton = ({ className = "", label = "Mein Solar-Potenzial entdecken" }: Props) => (
  <a
    href={SOLARRECHNER_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`btn-primary md:animate-glow-breathe ${className}`}
  >
    {label}
    <ArrowRight size={18} />
  </a>
);

export default SolarrechnerButton;
